<template>
  <div>
    <section class="section services-insurance">
      <b-row>
        <b-col cols="12">
          <div v-if="is_flight_and_stay_package">
            <h2 class="vb-heading mb-4">Assicurazione medico bagaglio</h2>
            <p>I pacchetti viaggio includono sempre la Polizza Base o Top Booking Basic (per prodotto Eden Viaggi). I servizi inclusi sono:</p>
            <ul>
              <li>rimborso o pagamento spese mediche con massimali di 1.000, 5.000 o 30.000 € in base al Paese di destinazione</li>
              <li>l'assicurazione bagaglio e acquisti di prima necessità in caso di furto, mancata consegna bagagli, scippo, rapina, ecc.</li>
              <li>assistenza alla persona 22 prestazioni fornite attraverso la struttura organizzativa in funzione 24h. Tra le prestazioni: consulenza medica; rimpatrio e/o rientro sanitario; rientro anticipato o prolungamento del soggiorno; protezione carte di credito; anticipo cauzione penale all’estero.</li>
              <li>il servizio My Clinic: E’ la piattaforma digitale attraverso cui potrai ricevere assistenza in viaggio per tutta la tua famiglia scaricando l'App MyAlpitour World.</li>
              <li>il servizio Senior Assistance: un servizio di assistenza medica per i familiari over 65 che sono restati a casa</li>
            </ul>
            <p><strong>I pacchetti Edenviaggi non includono il servizio My Clinic e il servizio Senior Assistance.</strong></p>
            <hr />
<!--            <p>
              <strong>IN QUESTA PRENOTAZIONE E' INCLUSA GRATUITAMENTE LA</strong><br/><br/>
              <strong class="text&#45;&#45;lg">TOPBOOKING EASY PLUS</strong>
            </p>
            <p>a) GARANZIA ANNULLAMENTO/MODIFICA per motivi certificabili fino alla data partenza per:</p>
            <ul>
              <li>Malattia, infortunio o decesso certificati dal medico. È compreso il Covid-19 e sue varianti/mutazioni;</li>
              <li>Motivi professionali come la Revoca, il Licenziamento, la Sospensione e l’Assunzione; </li>
              <li>Variazione della data di matrimonio, esami scolastici, di abilitazione o di un concorso;</li>
              <li>Nomina dell’assicurato a giurato o sua testimonianza resa all’Autorità Giudiziaria;</li>
              <li>Danni materiali all’abitazione dell’Assicurato;</li>
              <li>Furto dei documenti necessari per l’espatrio;</li>
              <li>Impossibilità di raggiungere il luogo di partenza a causa di Calamità naturali, Improvvisi avvenimenti stradali, Guasti od incidenti al mezzo utilizzato, Scioperi dei mezzi pubblici.</li>
            </ul>
            <p>b) INTEGRAZIONE DEL RIMBORSO DELLE SPESE MEDICHE (coperte dalla Top Booking Basic) durante il viaggio per malattia o infortunio fino a € 5.000.</p>-->
            <p>
              Su alcune destinazioni come USA e Canada è fortemente consigliata la sottoscrizione di assicurazioni mediche con massimali più ampi. Parlane col tuo assicuratore.<br/>
              Per ulteriori approfondimenti consulta le <router-link :to="{ name: 'terms' }">condizioni generali</router-link> del sito vacanze by VadoBay e le <a target="_blank" href="https://vacanze.vadobay.com/assets/condizioni_uso_vacanzeByVadoBay.pdf">condizioni assicurative di Alpitour</a>.<br/>
              <span v-if="emailSupport">(Ricorda che nei pacchetti viaggio non è mai inclusa l’assicurazione annullamento. Per maggiori informazioni scrivici a <a :href="`mailto:${emailSupport}`"> {{ emailSupport }} </a>).</span>
            </p>
          </div>
          <div v-else>
            <p>
              Su alcune destinazioni come USA e Canada è fortemente consigliata la sottoscrizione di assicurazioni mediche con massimali ampi. Parlane col tuo assicuratore.<br/>
              Per ulteriori approfondimenti consulta le <router-link :to="{ name: 'terms' }">condizioni generali</router-link> del sito vacanze by VadoBay e le <a target="_blank" href="https://vacanze.vadobay.com/assets/condizioni_uso_vacanzeByVadoBay.pdf">condizioni assicurative di Alpitour</a>.<br/>
              Ricorda che l’assicurazione annullamento non è inclusa in questa prenotazione. Per maggiori informazioni scrivici a <a :href="`mailto:${emailSupport}`"> {{ emailSupport }} </a>).
            </p>
          </div>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "services-insurance",
  computed: {
    ...mapGetters("liveat", ["is_flight_and_stay_package"]),
    emailSupport() {
      return this.get_config("site.emailSupport");
    },
  },
};
</script>

<style lang="scss" scoped>

  .services-insurance {
    background-color: $white;
    border-radius: $border-radius-lg;
    padding: $grid-gutter-20;

    &.section {
      margin-bottom: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }

    ul:last-child {
      margin-bottom: 0;
    }
  }

</style>
